/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.scss';

export const TOGGLE_BUTTON_VARIANTS = {
  NO_TEXT: 'no-text'
};

const propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(Object.values(TOGGLE_BUTTON_VARIANTS)),
  disabled: PropTypes.bool,
  infoText: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string
};

const ToggleButton = forwardRef(
  (
    {values, onChange, checked, variant, disabled = false, infoText = null, className, name = null},
    ref
  ) => {
    const [isChecked, setIsChecked] = useState(checked);

    const toggleState = (state = null, byPassDisabled = false) => {
      if (!byPassDisabled && disabled) return;

      const newState = state === null ? !isChecked : state;

      setIsChecked(newState);
    };

    useImperativeHandle(ref, () => ({
      toggleState
    }));

    const getValue = () => (isChecked ? values[1] : values[0]);

    const emitChange = () => (typeof onChange === 'function' ? onChange(getValue()) : null);

    useEffect(emitChange, [isChecked]);

    return (
      <div
        className={cx(styles['toggle-button'], className, {
          [styles[`toggle-button--${variant}`]]: variant,
          [styles['toggle-button--disabled']]: disabled
        })}>
        <input name={name} value={getValue().value} type="hidden" />

        <button
          type="button"
          aria-label="plan-toggle-button"
          onClick={() => toggleState()}
          className={cx({
            [styles['toggle-button__input']]: true,
            [styles['toggle-button__input--checked']]: isChecked
          })}>
          <span className={styles['toggle-button__item']}>{values[0]?.text}</span>
          <span className={styles['toggle-button__item']}>{values[1]?.text}</span>
        </button>

        {infoText && (
          <h3
            className={`${styles['toggle-button__info']} heading-4`}
            onClick={() => toggleState()}>
            {infoText}
          </h3>
        )}
      </div>
    );
  }
);

ToggleButton.propTypes = propTypes;

export default ToggleButton;
